<template>
    <div>
        <!-- 문의내용 -->
        <v-sheet color="transparent" class="page-text pa-16" style="white-space: pre-line">
            <template v-if="!isUserAuthorized">
                <span class="grey-9--text"> 열람할 권한이 없습니다. </span>
            </template>
            <template v-else>
                <template v-if="item.content">
                    {{ item.content }}
                </template>
                <template v-else>
                    <span class="grey-9--text"> 작성한 내용이 없습니다. </span>
                </template>

                <v-row align="baseline" class="mt-14 row--x-small page-text--sm grey-9--text">
                    <v-col cols="auto">
                        <span> 작성일시: {{ item.createdAt.toDateTime() }} </span>
                    </v-col>

                    <!-- 액션버튼(개인회원) -->
                    <template v-if="isUserItem">
                        <v-col cols="auto">·</v-col>
                        <v-col cols="auto">
                            <expo-inquiry-form v-bind="{ value: item, program }" @input="updateItem">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="{ ...attrs, ...attrs_actionBtn, loading, disabled: disabled_userUpdate }" v-on="on">
                                        <span> 수정하기 </span>
                                    </v-btn>
                                </template>
                            </expo-inquiry-form>
                        </v-col>
                        <v-col cols="auto">·</v-col>
                        <v-col cols="auto">
                            <v-btn v-bind="{ ...attrs_actionBtn, loading }" @click="remove">
                                <span> 삭제하기 </span>
                            </v-btn>
                        </v-col>
                    </template>
                </v-row>
            </template>
        </v-sheet>

        <!-- 답변내용 -->
        <template v-if="isUserAuthorized">
            <v-divider />
            <v-sheet color="transparent" class="page-text pa-16" style="white-space: pre-line">
                <template v-if="item.reply">
                    {{ item.reply }}
                </template>
                <template v-else>
                    <span class="grey-9--text"> 답변이 등록되지 않았습니다. </span>
                </template>

                <v-row align="baseline" class="mt-14 row--x-small page-text--sm grey-9--text">
                    <template v-if="item.repliedAt">
                        <v-col cols="auto">
                            <span> 답변일시: {{ item.repliedAt.toDateTime() }} </span>
                        </v-col>
                    </template>

                    <!-- 액션버튼(기업회원) -->
                    <template v-if="isUserHost">
                        <template v-if="item.repliedAt">
                            <v-col cols="auto">·</v-col>
                        </template>
                        <v-col cols="auto">
                            <expo-inquiry-reply v-bind="{ value: item, program }" @input="updateItem">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="{ ...attrs, ...attrs_actionBtn, loading }" v-on="on">
                                        <span>
                                            <template v-if="item.reply"> 수정하기 </template>
                                            <template v-else> 답변하기 </template>
                                        </span>
                                    </v-btn>
                                </template>
                            </expo-inquiry-reply>
                        </v-col>
                        <v-col cols="auto">·</v-col>
                        <v-col cols="auto">
                            <v-btn v-bind="{ ...attrs_actionBtn, loading }" @click="hide">
                                <span> 블라인드 </span>
                            </v-btn>
                        </v-col>
                    </template>
                </v-row>
            </v-sheet>
        </template>
        <v-divider v-if="item._id != items.at(-1)._id" />
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { initExpoProgram, initExpoInquiry } from "@/assets/variables";

import ExpoInquiryForm from "../expo-inquiry-form.vue";
import ExpoInquiryReply from "../expo-inquiry-reply.vue";

const attrs_actionBtn = {
    small: true,
    text: true,
    color: "grey-9",

    height: 16,

    class: "pa-0",
};

export default {
    components: {
        ExpoInquiryForm,
        ExpoInquiryReply,
    },
    props: {
        item: { type: Object, default: initExpoInquiry },
        items: { type: Array, default: () => [] },
        program: { type: Object, default: initExpoProgram },

        loading: { type: Boolean, default: false },
    },
    data: () => ({
        attrs_actionBtn,
    }),
    computed: {
        ...mapGetters(["_user", "doesUserHaveConsoleScope"]),
        isUserHost() {
            return this._user == this.item._host;
        },
        isUserItem() {
            return this._user == this.item._user;
        },
        disabled_userUpdate() {
            return this.item.isReplied;
        },
        isUserAuthorized() {
            const needsAuthorization = this.item.isHidden || this.item.isSecret;
            const hasUserAuthorities = this.isUserItem || this.isUserHost || this.doesUserHaveConsoleScope;

            return !(needsAuthorization && !hasUserAuthorities);
        },
    },
    methods: {
        remove() {
            const go = confirm("해당 문의를 삭제하시겠습니까?");
            if (!go) return;

            this.$emit("remove", this.item);
        },
        hide() {
            let text = this.item.isHidden ? "해제" : "설정";
            const go = confirm(`해당 게시글의 블라인드를 ${text}하시겠습니까?`);
            if (!go) return;

            this.$emit("update", {
                _id: this.item._id,
                _program: this.item._program,
                isHidden: !this.item.isHidden,
            });
        },
        updateItem(item) {
            this.$emit("updateItem", item);
        },
    },
};
</script>

<style>
</style>